module.exports = __webpack_public_path__ + "img/caratula_mas al sur.0f17238b.jpg";